import { Icon } from "@iconify/react"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import logo from "../media/blueLogo.png"
import { getAuth,signOut } from "firebase/auth"
import useGenStore from "../store/genstore"
import "../css/admin.css"
function AdminSideBar(){
    const navigate = useNavigate()
    const viewAdminDashboard = useGenStore((s)=>s.viewAdminDashboard)
    const viewAnalytics = useGenStore((s)=>s.viewAnalytics)
    const viewOrders = useGenStore((s)=>s.viewOrders)
    const viewAdminDashboardLink = useGenStore((s)=>s.viewAdminDashboardLink)
    const setAdminSideNav = useGenStore((s)=>s.setAdminSideNav)
    const viewEmails = useGenStore((s)=>s.viewEmails)
    const viewClearedOrders = useGenStore((s)=>s.viewClearedOrders)
    const setViewAdminDashboard = useGenStore((s)=>s.setViewAdminDashboard)
    const setviewAnalytics = useGenStore((s)=>s.setviewAnalytics)
    const setViewClearedOrders = useGenStore((s)=>s.setViewClearedOrders)
    const setViewOrders = useGenStore((s)=>s.setViewOrders)
    const setviewEmails = useGenStore((s)=>s.setviewEmails)
    
    
            const logOut =()=>{
              Swal.fire({
                        title:"Are You Sure?",
                        text:"Please confirm you are signing out!",
                        icon:"question",
                        showConfirmButton:true,
                        confirmButtonText:"Log Out",
                        showCancelButton:true,
                        cancelButtonText:"Cancel",
                        cancelButtonColor:"#6a5acd"
                    
                    }).then((result)=>{
                        if(result.isConfirmed){
                        const auth = getAuth()
                        signOut(auth).then(()=>{
                            navigate("/auth")
                        }).catch(()=>{
                            Swal.fire("Error", "An error occured", "error")
                        })
                        }
                      
                    })
        
          
        }
            

    return (
        <div className="asbWrap">
            <div className="asbTop">
                   <img src={logo} alt="" />
            </div>
            <div className="asbBtm">
                <div className="asbLinks">
                    <div
                    onClick={()=>{
                        setViewAdminDashboard()
                        setAdminSideNav(false)

                    }}
                     className={` asbLink ${viewAdminDashboardLink ? "asbLinkActive" : ""}`}>
                        <div className="asbLinkIcon">
                          <Icon icon="solar:armchair-2-linear" className="faIcon"/>
                        </div>
                        <div className="asbLinkName">
                            <span>Dashboard</span>
                        </div>
                    </div>
                    <div
                     onClick={()=>{
                        setViewOrders()
                        setAdminSideNav(false)
                    }}

                     className={` asbLink ${viewOrders ? "asbLinkActive" : ""}`}>
                        <div className="asbLinkIcon">
                          <Icon icon="solar:users-group-rounded-linear" className="faIcon"/>
                        </div>
                        <div className="asbLinkName">
                            <span>Orders</span>
                        </div>
                    </div>
                    <div
                        onClick={()=>{
                            setViewClearedOrders()
                        setAdminSideNav(false)

                        }}

                     className={` asbLink ${viewClearedOrders ? "asbLinkActive" : ""}`}>
                        <div className="asbLinkIcon">
                          <Icon icon="solar:check-circle-linear" className="faIcon"/>
                        </div>
                        <div className="asbLinkName">
                            <span>Cleared Orders</span>
                        </div>
                    </div>
                    <div
                    onClick={()=>{

                        setviewAnalytics()
                        setAdminSideNav(false)

                    }}

                     className={` asbLink ${viewAnalytics ? "asbLinkActive" : ""}`}>
                        <div className="asbLinkIcon">
                          <Icon icon="solar:diagram-up-bold" className="faIcon"/>
                        </div>
                        <div className="asbLinkName">
                            <span>Analytics</span>
                        </div>
                    </div>
                    <div
                                        onClick={()=>{
                                            setviewEmails()
                                            setAdminSideNav(false)

                                        }}

                     className={` asbLink ${viewEmails ? "asbLinkActive" : ""}`}>
                        <div className="asbLinkIcon">
                          <Icon icon="solar:letter-linear" className="faIcon"/>
                        </div>
                        <div className="asbLinkName">
                            <span>Emails</span>
                        </div>
                    </div>
                    <div className="asbLink" onClick={()=>logOut()}>
                        <div className="asbLinkIcon">
                          <Icon icon="solar:logout-2-outline" className="faIcon"/>
                        </div>
                        <div className="asbLinkName">
                            <span>Sign Out</span>
                        </div>
                    </div>
                </div>

            </div>
            
        </div>
    )
}
export default AdminSideBar